module.exports = __webpack_public_path__ + "static/img/login_bgpic.33cece0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login_bgpic.png
// module id = sYnm
// module chunks = 1